module.exports = __webpack_public_path__ + "static/media/fire-testimonial-3.d4f81506.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/callouts/fire-testimonial-3.jpg
// module id = 1156
// module chunks = 0